import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const List = styled.ol`
  list-style: decimal;
  padding-inline-start: 1.5em;

  a {
    text-decoration: underline;
  }

  li {
    margin-bottom: 4px;
  }

  code {
    font-family: var(--font-family-mono);
    background: ${Colors.GS300};
    padding: 4px 0;
  }
`
